const GetRequest = () => {
  // 获取当前页面的 URL
  const url = window.location.href

  // 创建 URLSearchParams 对象来解析 URL 中的参数
  const params = new URLSearchParams(url.split('?')[1])

  // 创建一个空对象来存储参数
  const paramsObj = {}

  // 遍历 URLSearchParams 对象，并将参数存储到对象中
  for (const [key, value] of params) {
    paramsObj[key] = value
  }

  // 返回参数对象
  return paramsObj
}

const OpenInWebview = () => {
  // 获取用户代理信息并转为小写
  let ua = navigator.userAgent.toLowerCase();

  // 如果是在微信浏览器中打开
  if (ua.match(/MicroMessenger/i) === 'micromessenger') { 
    return false;
  } 
  
  // 如果是在QQ浏览器中打开
  else if (ua.match(/QQ/i) === 'qq') { 
    return false;
  } 
  
  // 如果是在微博浏览器中打开
  else if (ua.match(/WeiBo/i) === "weibo") {
    return false;
  } 
  
  // 如果是在Android设备上
  else {
    if (ua.match(/Android/i) != null) {
      // 若没有匹配到"browser"关键词，则认为是在Webview中
      return ua.match(/browser/i) == null;
    } 
    
    // 如果是在iPhone设备上
    else if (ua.match(/iPhone/i) != null) {
      // 若没有匹配到"safari"关键词，则认为是在Webview中
      return ua.match(/safari/i) == null;
    } 
    
    // 其他设备
    else {
      return (ua.match(/macintosh/i) == null && ua.match(/windows/i) == null);
    }
  }
}
export default {
  GetRequest,
  OpenInWebview,
}



export {
  GetRequest,
  OpenInWebview,
}
